// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loader_loadingContainer__yaP07"};